function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M7.5.462a1.465 1.465 0 0 0-.494-.326A1.466 1.466 0 0 0 6.431 0H.625A.64.64 0 0 0 0 .65v10.829c0 .357.281.65.625.65h8.75a.64.64 0 0 0 .625-.65v-7.8a1.628 1.628 0 0 0-.131-.598 1.54 1.54 0 0 0-.313-.514L7.5.462zm-.594.61l2.038 2.12a.697.697 0 0 1 .143.279H6.67V.923a.713.713 0 0 1 .262.15h-.025zm2.256 10.193H.838V.864h5v2.82c0 .358.282.65.626.65h2.706v6.93h-.007zM2.5 5.415v.435a.202.202 0 0 0 .194.215H7.288a.2.2 0 0 0 .212-.196v-.454a.202.202 0 0 0-.194-.215H2.712a.2.2 0 0 0-.212.195v.02zm.206 1.514c-.112-.006-.2.084-.206.201v.449a.202.202 0 0 0 .194.215H7.288a.2.2 0 0 0 .212-.196V7.15a.202.202 0 0 0-.194-.215H2.712l-.006-.006zm0 1.736c-.112-.007-.2.084-.206.201v.449a.202.202 0 0 0 .194.214H7.288a.2.2 0 0 0 .212-.195v-.455a.202.202 0 0 0-.194-.214h-4.6z"
});

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.13385020.svg";
export { ForwardRef as ReactComponent };